import PropTypes from "prop-types";
import React from "react";

import Col from "~/components/layout/Col";
import Row from "~/components/layout/Row";

import Cta from "~/components/Cta";
import TwitterTimeline from "~/components/TwitterTimeline";

const ArticleSidebar = ({ ctas = [], hideTwitter = false }) => (
    <Row>
        {ctas.map(({ title, links }, index) => (
            <Col key={`${title}-${index}`}>
                <Cta {...{ links, title }} backgroundColor="white" />
            </Col>
        ))}
        {!hideTwitter ? (
            <Col>
                <TwitterTimeline screenName="Cree" />
            </Col>
        ) : null}
    </Row>
);

ArticleSidebar.propTypes = {
    ctas: PropTypes.arrayOf(PropTypes.shape({})),
    hideTwitter: PropTypes.bool,
};

export default ArticleSidebar;
